// extracted by mini-css-extract-plugin
export default {"content-editable":"content-editable___yyWlz","placeholder":"placeholder___k2Q2X","picker-container":"picker-container___ix7JY","picker-item":"picker-item___Ol9Av"};